module.exports = __webpack_public_path__ + "static/media/user_icon.fb64ebdb.png";